import { render, staticRenderFns } from "./SiteManagement.vue?vue&type=template&id=67089ca2&scoped=true&"
import script from "./SiteManagement.vue?vue&type=script&lang=js&"
export * from "./SiteManagement.vue?vue&type=script&lang=js&"
import style0 from "./SiteManagement.vue?vue&type=style&index=0&id=67089ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67089ca2",
  null
  
)

export default component.exports